import { classNames } from 'libs/react';
import { Icon } from './Icon';
import { React } from 'libs/react';
import './CreationMenu.scss';
import { Button } from './Button';
/**
 * @component CreationMenu
 * @since 1.0.0
 */
export function CreationMenu(props) {
    const { style, active, buttonWithLabel, hideButton, label } = Object.assign({ style: 'normal' }, props);
    /**
     * @function onOpen
     * @since 1.0.0
     * @hidden
     */
    function onOpen() {
        if (props.onOpen) {
            props.onOpen();
        }
    }
    const className = classNames('creation-menu', 'creation-menu--' + style, { 'creation-menu--is-active': active }, { 'creation-menu--is-hidden': hideButton }, props.className);
    return (React.createElement("div", { className: className },
        !hideButton && !buttonWithLabel && (React.createElement("div", { className: "creation-button", onClick: () => onOpen() },
            React.createElement(Icon, { className: "creation-button-picto", value: "plus" }))),
        !hideButton && buttonWithLabel && (React.createElement(Button, { style: "primary", label: t(label || 'Create'), onPress: () => onOpen() })),
        React.createElement("div", { className: "creation-menu-body" }, props.children)));
}
